module.exports = __webpack_public_path__ + "static/img/GIBSON.64800d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/GIBSON.jpg
// module id = RpjM
// module chunks = 0